import request, { baseURL } from '@/api/request'

// 查询全媒体运营销售表
export const getListPage = (params) => {
  return request({
    url: 'admin/activity/adm/activityMediaSale/getListPage',
    method: 'get',
    params
  })
}

// 编辑 or 修改全媒体运营销售
export const editActivityMediaSale = (data) => {
  let url = 'admin/activity/adm/activityMediaSale/addActivityMediaSale'
  if (data.id) {
    url = 'admin/activity/adm/activityMediaSale/updateActivityMediaSale'
  }
  return request({
    url,
    method: 'post',
    data
  })
}

// 修改销售状态
export const updateState = (data) => {
  return request({
    url: 'admin/activity/adm/activityMediaSale/updateState',
    method: 'post',
    data
  })
}

// 查询全媒体运营销售学员表
export const getStudentListPage = (params) => {
  return request({
    url: 'admin/activity/adm/activityMediaSaleUser/getListPage',
    method: 'get',
    params
  })
}

// 下载导入模板
export const downloadTemplate = () => {
  window.open(`${baseURL}/activity/adm/activityMediaSaleUser/downloadTemplate`)
}

// 导入学员
export const importUser = (data) => {
  return request({
    url: 'activity/adm/activityMediaSaleUser/importUser',
    method: 'post',
    upload: true,
    data
  });
}

// 检查手机号是否已经绑定销售
export const getCountByPhone = (params) => {
  return request({
    url: 'admin/activity/adm/activityMediaSaleUser/getCountByPhone',
    method: 'get',
    params
  })
}

// 添加or 修改全媒体运营销售学员
export const editActivityMediaSaleUser = (data) => {
  let url = 'admin/activity/adm/activityMediaSaleUser/addActivityMediaSaleUser'
  if (data.id) {
    url = 'admin/activity/adm/activityMediaSaleUser/updateActivityMediaSaleUser'
  }
  return request({
    url,
    method: 'post',
    data
  })
}

// 删除全媒体运营销售学员
export const delActivityMediaSaleUser = (data) => {
  return request({
    url: 'admin/activity/adm/activityMediaSaleUser/delActivityMediaSaleUser',
    method: 'post',
    data
  })
}
